let index: number = 0;

const NFvByStoreGridPluginSettings: IPluginSettings = {
    name: 'Фасовка',
    mnemocode: 'nfv_by_store_plugin',
    permission: 'RequestForMovement',
    columns: [{
        order: index++,
        propertyName: 'nFv',
        propertyType: 'number',
        displayName: 'Фасовка',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }],
}

export default NFvByStoreGridPluginSettings